import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StrikethroughSIcon(props: IconProps) {
    return <Icon {...props} iconKey={"strikethrough_s"}/>
}
